"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChangePasswordValidation = void 0;
const yup = __importStar(require("yup"));
const useLocale_1 = require("../../hooks/useLocale/useLocale");
const messages_1 = require("../../core/i18n/messages");
const useChangePasswordValidation = () => {
    const { formatMessage } = (0, useLocale_1.useLocale)();
    const schema = yup.object().shape({
        oldPassword: yup.string().required(formatMessage({ id: messages_1.AppMessages['common.validation.required'] })),
        newPassword: yup
            .string()
            .min(8, formatMessage({ id: messages_1.AppMessages['changePassword.validation.length'] }))
            .required(formatMessage({ id: messages_1.AppMessages['common.validation.required'] })),
        repeatPassword: yup
            .string()
            .min(8, formatMessage({ id: messages_1.AppMessages['changePassword.validation.length'] }))
            .oneOf([yup.ref('newPassword'), null], formatMessage({ id: messages_1.AppMessages['changePassword.validation.difference'] }))
            .required(formatMessage({ id: messages_1.AppMessages['common.validation.required'] })),
    });
    return { schema };
};
exports.useChangePasswordValidation = useChangePasswordValidation;
